CREDITALS_PATTERNS = {
  'email': /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/
}

module.exports = CREDITALS_PATTERNS